export default "__VITE_PUBLIC_ASSET__ea9a5d71__"